import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import GroupItem from "./GroupItem";
import getClassNameFactory from "../../utilities/classNames";

var Group = function Group(_ref) {
  var children = _ref.children,
      compact = _ref.compact,
      vertical = _ref.vertical;
  var getClassName = getClassNameFactory(Group.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        compact: compact,
        vertical: vertical
      })
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, children));
};

Group.displayName = "Group";
/* eslint-disable max-len */

Group.propTypes = {
  /**
   * Group.Item components
   */
  children: PropTypes.node.isRequired,

  /**
   * Decrease the gap between items
   */
  compact: PropTypes.bool,

  /**
   * Display vertically
   */
  vertical: PropTypes.bool
};
/* eslint-enable max-len */

Group.Item = GroupItem;
export default Group;